import { render } from "./vincoli.vue?vue&type=template&id=1b36d14e&bindings={\"navigate\":\"props\"}"
import script from "./vincoli.vue?vue&type=script&lang=js"
export * from "./vincoli.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./vincoli.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script